import chunk from 'lodash/chunk';
import React, { Fragment, ReactNode } from 'react';
import { Hover } from '../../components/behavior/Hover';
import { Row } from '../../components/Grid';
import {
  Navigation,
  NavigationLink,
  NavigationList,
  NavigationListItem,
  NavigationListItemWithTriangle,
  NavigationWrapper
} from '../../components/Navigation';
import {
  selectIsPathContentLoaded,
  selectMenu
} from '../../provider/Typo3Provider/selectors';
import { MenuEntry, Typo3State } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import Locations from './Locations';
import MenuEntryColumns from './MenuEntryColumns';

interface NavigationContainerProps {}

const entriesPerColumn = 8;

const renderMenuEntryChildren = (children: MenuEntry[]) => (
  <MenuEntryColumns entriesPerColumn={entriesPerColumn}>
    {children}
  </MenuEntryColumns>
);

const renderMenuEntry = (
  childrenHandler: (entries: MenuEntry[]) => ReactNode
) => ({ children = [], link, title, uid }: MenuEntry, index: number) => {
  if (children.length) {
    const columns = chunk(children, entriesPerColumn);
    const numColumns = columns.length;
    return (
      <Hover
        key={index}
        timeout={250}
        render={({ hover, hoveredBefore, ...hoverProps }) => (
          <NavigationListItemWithTriangle
            key={uid}
            showTriangle={hover}
            {...hoverProps}
          >
            <NavigationLink to={link}>
              <span>{title}</span>
            </NavigationLink>
            {hover && (
              <NavigationWrapper
                width={numColumns > 1 ? 800 : undefined}
                {...hoverProps}
              >
                <Row noGap>{childrenHandler(children)}</Row>
              </NavigationWrapper>
            )}
          </NavigationListItemWithTriangle>
        )}
      />
    );
  }
  return (
    <NavigationListItem key={uid}>
      <NavigationLink to={link}>
        <span>{title}</span>
      </NavigationLink>
    </NavigationListItem>
  );
};

interface NavigationContentProps {
  typo3: Typo3State;
}

const NavigationContent = ({ typo3 }: NavigationContentProps) => {
  const main = selectMenu(typo3, 'main');
  const locations = selectMenu(typo3, 'locations');
  const [, countries = null] = selectMenu(typo3, 'footer');
  return (
    <Fragment>
      {main.map(renderMenuEntry(renderMenuEntryChildren))}
      {countries && (
        <Locations
          entriesPerColumn={entriesPerColumn}
          locationEntries={locations}
          countryEntries={countries.children || []}
        />
      )}
    </Fragment>
  );
};

const NavigationContainer = ({
  typo3
}: NavigationContainerProps & WithTypo3Props) => {
  return (
    <Navigation type='main'>
      <NavigationList inlined>
        {selectIsPathContentLoaded(typo3) && (
          <NavigationContent typo3={typo3} />
        )}
      </NavigationList>
    </Navigation>
  );
};

export default withTypo3(NavigationContainer);
